<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                USUÁRIO -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">CPF (login)</label>
                            <b-form-input
                                type="text"
                                maxlength="14"
                                v-model="usuarioDto.cpf"
                                @input="$v.usuarioDto.cpf.$touch()"
                                :state="$v.usuarioDto.cpf.$error ? false : null"
                                :disabled="desabilitarCpf"
                                v-mask="'###.###.###-##'"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O CPF do usuário é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="9">
                        <b-form-group>
                            <label class="required">Nome</label>
                            <b-form-input
                                type="text"
                                v-model="usuarioDto.nome"
                                @input="$v.usuarioDto.nome.$touch()"
                                :state="
                                    $v.usuarioDto.nome.$error ? false : null
                                "
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O nome do usuário é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label class="required">E-mail</label>
                            <b-form-input
                                type="text"
                                v-model="usuarioDto.email"
                                @input="$v.usuarioDto.email.$touch()"
                                :state="
                                    $v.usuarioDto.email.$error ? false : null
                                "
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >Forneça um email
                                válido</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label class="required">Telefone</label>
                            <b-form-input
                                maxlength="15"
                                type="text"
                                v-model="usuarioDto.telefone01"
                                @input="$v.usuarioDto.telefone01.$touch()"
                                :state="
                                    $v.usuarioDto.telefone01.$error
                                        ? false
                                        : null
                                "
                                v-mask="['(##) ####-####', '(##) #####-####']"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O telefone do usuário é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Celular</label>
                            <b-form-input
                                maxlength="15"
                                type="text"
                                v-model="usuarioDto.telefone02"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="salvarForm()"
                :disabled="!habilitarSalvar"
                class="mr-2"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
            <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                <span> <i class="fa fa-history"></i> Voltar </span>
            </b-button>
            <div class="float-right">
                <label class="required ml-3 pt-2"></label>
                <label class="ml-2 pt-2">Campos Obrigatórios</label>
            </div>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required, email, minLength } from 'vuelidate/lib/validators'
import FornecedoresUsuariosServicos from './../../fornecedor/usuarios/UsuariosServicos'
import UsuariosFornecedorServicos from './UsuariosFornecedorServicos'

export default {
    props: {
        gestaoInterna: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            erros: [],
            operacao: '',
            usuarioDto: {
                nome: '',
                telefone01: '',
                telefone02: '',
                email: '',
                cpf: ''
            }
        }
    },

    methods: {
        salvarForm() {
            let usuario = {
                nome: this.usuarioDto.nome.toUpperCase(),
                telefone01: this.usuarioDto.telefone01.apenasNumeros(),
                telefone02: this.usuarioDto.telefone02.apenasNumeros(),
                email: this.usuarioDto.email.toLowerCase(),
                cpf: this.usuarioDto.cpf.apenasNumeros()
            }
            if (this.operacao === 'INSERIR') {
                this.inserirUsuario(usuario)
            } else {
                usuario.usuarioId = this.$route.params.usuarioId
                this.atualizarUsuario(usuario)
            }
        },

        voltar() {
            this.erros = []
            if (this.gestaoInterna) {
                if (this.operacao === 'ATUALIZAR') {
                    this.$router.push({
                        name: 'UsuariosFornecedor_Detalhar',
                        params: { usuarioId: this.$route.params.usuarioId }
                    })
                } else {
                    this.$router.push({ name: 'UsuariosFornecedor' })
                }
            } else {
                if (this.operacao === 'ATUALIZAR') {
                    this.$router.push({
                        name: 'Fornecedores_Usuarios_Detalhar',
                        params: { usuarioId: this.$route.params.usuarioId }
                    })
                } else {
                    this.$router.push({ name: 'Fornecedores_Usuarios' })
                }
            }
        },

        inserirUsuario(usuario) {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.inserirUsuario(
                    this.$route.params.fornecedorId,
                    usuario
                )
            } else {
                promisse = FornecedoresUsuariosServicos.inserirUsuario(usuario)
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterUsuario() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.obterPorId(
                    this.$route.params.fornecedorId,
                    this.$route.params.usuarioId
                )
            } else {
                promisse = FornecedoresUsuariosServicos.obterPorId(
                    this.$route.params.usuarioId
                )
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencherFormulario(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarUsuario(usuario) {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.atualizarUsuario(
                    this.$route.params.fornecedorId,
                    usuario
                )
            } else {
                promisse =
                    FornecedoresUsuariosServicos.atualizarUsuario(usuario)
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso(
                            this.$route.params.usuarioId
                        )
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso(usuarioId) {
            this.erros = []
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$store.dispatch('setRecarregar', true)
            if (this.gestaoInterna) {
                this.$router.push({
                    name: 'UsuariosFornecedor_Detalhar',
                    params: { usuarioId: usuarioId }
                })
            } else {
                this.$router.push({
                    name: 'Fornecedores_Usuarios_Detalhar',
                    params: { usuarioId: usuarioId }
                })
            }
        },

        preencherFormulario(data) {
            this.usuarioDto.nome = data.nome
            this.usuarioDto.telefone01 = this.$mask(data.telefone01, [
                '(##) ####-####',
                '(##) #####-####'
            ])
            this.usuarioDto.telefone02 = this.$mask(data.telefone02, [
                '(##) ####-####',
                '(##) #####-####'
            ])
            this.usuarioDto.email = data.email
            if (this.operacao === 'ATUALIZAR') {
                this.usuarioDto.usuarioId = data.usuarioId
                this.usuarioDto.cpf = this.$mask(data.login, '###.###.###-##')
            }
        },

        resetarFormulario() {
            this.usuarioDto.nome = ''
            this.usuarioDto.email = ''
            this.usuarioDto.telefone01 = ''
            this.usuarioDto.telefone02 = ''
            this.usuarioDto.cpf = ''
        },

        processarRota(rota) {
            if (
                rota.name === 'Fornecedores_Usuarios_Inserir' ||
                rota.name === 'UsuariosFornecedor_Inserir'
            ) {
                this.operacao = 'INSERIR'
            } else if (
                rota.name === 'Fornecedores_Usuarios_Atualizar' ||
                rota.name === 'UsuariosFornecedor_Atualizar'
            ) {
                this.operacao = 'ATUALIZAR'
                this.obterUsuario()
            }
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        desabilitarCpf() {
            return this.operacao === 'ATUALIZAR'
        }
    },

    watch: {
        $route(to, from) {
            this.processarRota(to)
        }
    },

    created() {
        this.processarRota(this.$route)
    },

    validations: {
        usuarioDto: {
            nome: {
                required
            },
            cpf: {
                required,
                cpfValido(value) {
                    return this.$cpfValido(value.apenasNumeros())
                }
            },
            telefone01: {
                required,
                minLength: minLength(14)
            },
            email: {
                required,
                email
            }
        }
    }
}
</script>
